import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';

export class MyMissingTranslationHandler implements MissingTranslationHandler {
    handle(params: MissingTranslationHandlerParams): string {
        // TODO: re-introduce after fixing dropdown translations
        // return '*TODO*' + params.key;
        return params.key;
    }
}
